import { baseErrorMessages } from '@repo/lib/messages/baseErrorMessages';
import { useMutation, useQueryClient } from '@tanstack/react-query';

import { useErrorMessage } from '#error-message/useErrorMessage';

import type { GroupAvatarUploadData } from './groupService';

import { GroupService } from './groupService';
import { GroupKey } from './keys';

export function usePostGroupAvatar() {
  const queryClient = useQueryClient();
  const postGroupAvatarMutation = useMutation({
    mutationFn: (data: GroupAvatarUploadData) => GroupService.postGroupAvatar(data).then((response) => response.data),
    onSuccess: (data: string, variables: GroupAvatarUploadData) => {
      queryClient.invalidateQueries({
        queryKey: [GroupKey.GROUP, variables.id],
      });
      queryClient.invalidateQueries({
        queryKey: [GroupKey.GROUPS],
      });
      queryClient.invalidateQueries({
        queryKey: [GroupKey.ASSIGNED_GROUPS_INFINITE],
      });
    },
  });

  const errorMessage = useErrorMessage(postGroupAvatarMutation.error, baseErrorMessages);
  return { ...postGroupAvatarMutation, errorMessage };
}
